<template>
  <v-row>
    <v-col
      v-for="location in locationsWithSchoolYears"
      :key="location.name"
      cols="12"
      lg="3"
      md="6"
      sm="12">
      <LocationValueList
        :icon="ReportMoneyIcon"
        :rows="location.rows"
        :title="location.name"
        :total="location.total" />
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { ReportMoneyIcon } from 'vue-tabler-icons';
import { useMetricsStore } from '@/stores/metrics';
import { currencyService } from '@/services/currency';
import LocationValueList from '@/components/metrics/LocationValueList.vue';

const metricsStore = useMetricsStore();

const locationsWithSchoolYears = computed(() =>
  Object.keys(metricsStore.metrics)
    .sort((a, b) => a.localeCompare(b, 'de'))
    .map((name) => {
      const isLoading = metricsStore.totalDifferenceLoadingStates[name] ?? false;
      const schoolYears = [...metricsStore.metrics[name].totalDifferenceBySchoolYear].sort(
        (a, b) => (b.start?.getTime() ?? 0) - (a.start?.getTime() ?? 0)
      );

      const buildRow = (label: string, amount: number, subText?: string) => ({
        name: label,
        value: currencyService.formatNumberToCurrency(amount),
        subText,
        isLoading,
        dimmed: amount === 0
      });

      return {
        name,
        rows: schoolYears.map((schoolYear) =>
          buildRow(schoolYear.name, schoolYear.totalDifference, schoolYear.isCurrent ? 'laufendes Schuljahr' : undefined)
        ),
        total: buildRow(
          'Gesamt',
          schoolYears.reduce((sum, schoolYear) => sum + schoolYear.totalDifference, 0)
        )
      };
    })
    .filter((location) => location.rows.length > 0)
);
</script>
